import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Ref } from '@eastsideco/salvo-ts';

@Component
export class ImageComparison extends ThemeComponent {
    @Ref() buttonNext!: HTMLButtonElement;
    @Ref() buttonPrevious!: HTMLButtonElement;
    @Ref() rangeInput!: HTMLInputElement;

    init() {
        this.$listen(this.buttonNext, 'click', () => {
            const valueString = this.style.cssText.split('--value:')[1];
            const value = Number(valueString.trim().replace('%;', ''));
            let newValue = value + 20;

            if (value == 90) {
                return;
            }

            if ((value + 20) > 90 ) {
                newValue = 90;
            }

            this.rangeInput.value = String(newValue);
            this.style.setProperty('--value', `${newValue}%`);
        });

        this.$listen(this.buttonPrevious, 'click', () => {
            const valueString = this.style.cssText.split('--value:')[1];
            const value = Number(valueString.trim().replace('%;', ''));
            let newValue = value - 20;

            if (value == 10) {
                return;
            }

            if ((value - 20) < 10 ) {
                newValue = 10;
            }

            this.rangeInput.value = String(newValue);
            this.style.setProperty('--value', `${newValue}%`);
        });
    }
}
